import React from "react"
import PropTypes from "prop-types"

class SubmitButton extends React.Component {
  static propTypes = {
    buttonClasses: PropTypes.string,
    buttonLabel: PropTypes.string.isRequired,
    disabled: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired
  }

  render() {
    const { buttonClasses, buttonLabel, disabled, onClick } = this.props

    return (
      <a
        data-no-turbolink
        className={buttonClasses}
        {...{
          disabled,
          onClick
        }}
      >
        {buttonLabel}
      </a>
    )
  }
}

export default SubmitButton
